// A quiet entry on the user's OWN profile (never rendered for anyone else's):
// one card, not a banner or popup. Opens the same Shopping Profile page as Settings.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Shirt } from "lucide-react";
import { getAccessToken } from "../../../awsAuth";
import "./ShoppingProfileEntry.scss";

const API_BASE = process.env.REACT_APP_API_BASE || process.env.REACT_APP_API || "http://localhost:5000";

export default function ShoppingProfileEntry({ isOwner }) {
  const navigate = useNavigate();
  const [completeness, setCompleteness] = useState(null);

  useEffect(() => {
    if (!isOwner) return undefined;
    let alive = true;
    (async () => {
      try {
        const token = await getAccessToken().catch(() => null);
        const res = await fetch(`${API_BASE}/api/shopping-profile`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
        if (!res.ok) return;
        const data = await res.json();
        if (alive) setCompleteness(data.completeness || null);
      } catch {
        /* the card still works without the progress label */
      }
    })();
    return () => {
      alive = false;
    };
  }, [isOwner]);

  if (!isOwner) return null;

  const done = completeness?.done ?? 0;
  const total = completeness?.total ?? 5;
  const status = !completeness ? "" : done === 0 ? "Налаштувати" : done === total ? "Усе заповнено" : `${done} з ${total}`;

  return (
    <button type="button" className="spEntry" onClick={() => navigate("/settings/shopping-profile")}>
      <span className="spEntry__icon"><Shirt size={18} /></span>
      <span className="spEntry__main">
        <strong>Shopping Profile</strong>
        <small>Розміри, стиль і вподобання для персональних рекомендацій</small>
      </span>
      {status ? <span className={`spEntry__status${done === 0 ? " is-new" : ""}`}>{status}</span> : null}
      <ChevronRight size={16} />
    </button>
  );
}
